import dayjs from 'dayjs'

export function mapCountryToIANATimezoneName(
    countryID: number,
): [string, number | undefined] {
    switch (countryID) {
        case 102: // Ireland
            return ['Europe/Dublin', 47]
        case 219:
            return ['Asia/Bangkok', 98]
        default:
            return [dayjs.tz.guess(), undefined]
    }
}
